<label class="st-field-label">{{label}}</label>
<select [id]="idVal" class="form-select st-dropdown-button" aria-label="Default select example" [value]="inputVal">
  <option *ngFor="let item of menuList" [value]="item">{{item}}</option>
</select>
